import { Injectable } from '@angular/core';
import * as amplitude from '@amplitude/analytics-browser';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  constructor() {
    amplitude.init(environment.amplitudeApiKey, {
      defaultTracking: true
    });
  }

  setContactId(contactId: string): void {
    amplitude.setUserId(contactId);
  }

  inicioEnrolamientoTarjeta(medio_pago_id: string): void {
    const eventProperties: Record<string, unknown> = {
      medio_pago_id: medio_pago_id
    };
    amplitude.track('inicioEnrolamientoTarjeta', eventProperties);
  }

  finEnrolamientoTarjeta(medio_pago_id: string, status_code: string): void {
    const eventProperties: Record<string, unknown> = {
      medio_pago_id: medio_pago_id,
      status_code: status_code
    };
    amplitude.track('finEnrolamientoTarjeta', eventProperties);
  }

  autenticacionEnrolamientoTarjeta(medio_pago_id: string, status_code: string): void {
    const eventProperties: Record<string, unknown> = {
      medio_pago_id: medio_pago_id,
      status_code: status_code
    };
    amplitude.track('autenticacionEnrolamientoTarjeta', eventProperties);
  }

  derivarOneclickTokenizacion(bin: string): void {
    const eventProperties: Record<string, unknown> = {
      bin: bin
    };
    amplitude.track('derivarOneclickTokenizacion', eventProperties);
  }
}